import React from 'react'

export default React.createContext({
  tree: {},
  updateTree: (e) => {},
})
